@if (vertente) {
  <div class="card-vertente">
    <div class="content">
      <img class="icon" [src]="findIconVertente(vertente)" [alt]="vertente?.descricao" [title]="vertente?.descricao">
      <p class="title" [style]="'color:' + findColorVertente(vertente)">{{vertente.descricao}}</p>
      <app-button [customStyle]="'background:' + findColorVertente(vertente) + '; border: 2px solid ' + findColorVertente(vertente) + '; color: #FFFFFF !important'"
      [txt]="'SAIBA MAIS'" (click)="irParaSaibaMais(vertente)"></app-button>
    </div>
  </div>
}
@if (!vertente) {
  <div id="container-cards-vertentes">
    @for (vertente of vertentes; track vertente) {
      <div class="card-vertente">
        <div class="content">
          <img class="icon" [src]="findIconVertente(vertente)" [alt]="vertente?.descricao" [title]="vertente?.descricao">
          <p class="title" [style]="'color:' + findColorVertente(vertente)">{{vertente.descricao}}</p>
          <app-button [customStyle]="'background:' + findColorVertente(vertente) + '; border: 2px solid ' + findColorVertente(vertente) + '; color: #FFFFFF !important'"
          [txt]="'SAIBA MAIS'" (click)="irParaSaibaMais(vertente)"></app-button>
        </div>
      </div>
    }
  </div>
}